import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const importdashboardApi = createApi({
  reducerPath: "importdashboardApi",
  baseQuery,
  tagTypes: ["Dashboard"],
  endpoints: (builder) => ({
    getimportDashboard: builder.query({
      query: ({
        page = 1,
        pageSize = 20,
        financialYear,
        cityId,
        organizationId,
      } = {}) => {
        let url = `${apiurl.Import_data}?pageNumber=${page}&pageSize=${pageSize}`;

        // ✅ Add filters if present
        if (financialYear) url += `&financialYear=${financialYear}`;
        if (cityId) url += `&cityId=${cityId}`;
        if (organizationId) url += `&organizationId=${organizationId}`;

        return url;
      },

      transformResponse: (response) => {
        const {
          totalCount = 0,
          data: rows = [],
          lastWeekPercentage = 0,
          lastMonthPercentage = 0,
          thisWeekPercentage = 0,
          thisMonthPercentage = 0,
          weekComparison = "-",
          monthComparison = "-",
        } = response?.data || {};

        return {
          rows,
          totalCount,
          lastWeekPercentage,
          lastMonthPercentage,
          thisWeekPercentage,
          thisMonthPercentage,
          weekComparison,
          monthComparison,
        };
      },
    }),
    getImportJobs: builder.query({
      query: ({
        financialYear = "2025-2026",
        cityId,
        organizationId,
      } = {}) => {
        let url = `${apiurl.Import_data}?financialYear=${financialYear}`;

        // ✅ Add filters if present
        // if (financialYear) url += `&financialYear=${financialYear}`;
        if (cityId) url += `&cityId=${cityId}`;
        if (organizationId) url += `&organizationId=${organizationId}`;

        return url;
      },

      transformResponse: (response) => {
        const {
          totalCount = 0,
          data: rows = [],
          lastWeekPercentage = 0,
          lastMonthPercentage = 0,
          thisWeekPercentage = 0,
          thisMonthPercentage = 0,
          weekComparison = "-",
          monthComparison = "-",
        } = response?.data || {};

        return {
          rows,
          totalCount,
          lastWeekPercentage,
          lastMonthPercentage,
          thisWeekPercentage,
          thisMonthPercentage,
          weekComparison,
          monthComparison,
        };
      },
    }),

    toggleimportLock: builder.mutation({
      query: ({ jobId, requestId }) => {
        const payload = {
          jobId,
          requestId,
          url: `/import/toggleLock/${jobId}`,
        };

        return {
          url: payload.url,
          method: "PUT",
          headers: {
            "X-Request-Id": requestId || `${Date.now()}`,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
      },
      invalidatesTags: ["Dashboard"],
    }),

    deleteImportJob: builder.mutation({
      query: ({ jobId, requestId, reason }) => {
        const payload = {
          jobId,
          requestId,
          reason,
          url: `/import/${jobId}`,
        };

        return {
          url: payload.url,
          method: "DELETE",
          headers: {
            "X-Request-Id": requestId || `${Date.now()}`,
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ reason }),
        };
      },
      invalidatesTags: ["Dashboard"],
    }),
  }),
});

export const {
  useGetimportDashboardQuery,
  useGetImportJobsQuery,
  useToggleimportLockMutation,
  useDeleteImportJobMutation,
} = importdashboardApi;
